import { useEffect } from 'react'

/**
 * リロード、タブを閉じる、別 URL への遷移など、SPA外への遷移をブラウザのダイアログで警告するためのフック
 */
export const useBrowserUnloadGuard = (shouldBlock: boolean) => {
  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (shouldBlock) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [shouldBlock])
}
